export default __webpack_public_path__ + "static/media/tommyClick.fa918f8e.png";